<template>
      <div no-body class="lku-item"> 
      <b-form-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-form-row>
      <b-form-row v-else>
        <b-col lg="11">
            <b-input-group>
                <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.jccostname" @keyup.13.native="search()" placeholder="Item Name" style="width:30% !important;"></b-form-input>
                  <b-form-input v-model="tblData.jccostcode" @keyup.13.native="search()" placeholder="Item Code" class="ml-1"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
            </b-input-group>

          </b-col>
      </b-form-row>
      <b-table
          class="m-0"
          ref="tblItem"
          responsive striped hover small
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(jccostcode)="data">
          <span v-if="(data.item.judul=='Y')"  style="font-weight:bold;">{{data.item.jccostcode}}</span>
          <span v-else >{{data.item.jccostcode}}</span>
        </template>
        <template v-slot:cell(jccostname)="data">
          <span v-if="(data.item.judul=='Y')" v-html="data.item.accname" style="font-weight:bold;"></span>
          <span v-else v-html="data.item.accname"></span>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss">
  .lku-item {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import item from "../../apis/budgetcostitem";

export default {
  data() {
    return {
      fields: [
          {
            key: "jccostcode",
            label: "Item Code",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "jccostname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "unitsize",
            thStyle: "width:80px",
            label: "UnitSize"
          },
          {
            key: "kodeacc",
            label: "GL Account#",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Master Item",
            thStyle: "width:100px",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 25,
        total: 0,
        sortBy: 'jccostcode',
        sortDesc: false,jccostcode:'',jccostname:''
      },
      lkuLoading:false
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.lkuLoading = false;
    },
    data: async function(ctx) {
      if(this.jasa){
        this.tblData.jasa = this.jasa; 
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const items= await item.list(this.tblData);    
      this.lkuLoading = false;
      return items;      

    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.jccostcode=  '';
        this.tblData.jccostname=  '';
    },    
    refresh() {
      this.$refs.tblItem.refresh();
    },
    search() {
      this.tblData.page=1;
      this.$refs.tblItem.refresh();
    }
  }
};
</script>
